import React from 'react';

const PageLoader = () => (
  <div className="page-loader">
    <div className="loader" />
  </div>
);

export default PageLoader;

